module.exports = __webpack_public_path__ + "static/img/achievments_bg1.5a33e7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achievments_bg1.jpg
// module id = PCnd
// module chunks = 0